export function getForterToken() {
  try {
    return typeof window !== "undefined" && typeof window.ccForterToken === "function" ? window.ccForterToken() : null;
  } catch {
    return null;
  }
}
